function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useMemo } from "react";
import Col from "../../Col";
import { isCarinaGlyph, remapIconSize } from "../../Icon/types";
import ChevronLeftIcon from "../../Icon/ChevronLeft";
import ChevronDownIcon from "../../Icon/ChevronDown";
import ChevronRightIcon from "../../Icon/ChevronRight";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useStyle } from "./AccordionIcon.styles";
import { resolveIds } from "../../../utils";
export var ICON_PLACEMENT = {
    START: 'start',
    END: 'end'
};
var Icon = function(param) {
    var icon = param.icon, isOpen = param.isOpen, isLeft = param.isLeft, chevronPlacement = param.chevronPlacement, _testID = param.testID, testID = _testID === void 0 ? 'accordion-icon' : _testID, isRtl = param.isRtl;
    var ref = useStyle(isOpen), chevronDown = ref.chevronDown, chevronLeft = ref.chevronLeft, chevronRight = ref.chevronRight, iconColor = ref.iconColor;
    var IconNode = useMemo(function() {
        var RenderIcon = icon;
        if (isLeft) {
            if (chevronPlacement === 'start') {
                return isRtl ? _jsx("span", _objectSpread({
                    css: chevronLeft
                }, resolveIds(undefined, testID, 'icon'), {
                    children: _jsx(ChevronLeftIcon, {
                        size: "m",
                        color: iconColor
                    })
                })) : _jsx("span", _objectSpread({
                    css: chevronRight
                }, resolveIds(undefined, testID, 'icon'), {
                    children: _jsx(ChevronRightIcon, {
                        size: "m",
                        color: iconColor
                    })
                }));
            }
            if (typeof RenderIcon === 'function') {
                if (isCarinaGlyph(RenderIcon)) {
                    return _jsx(RenderIcon, {
                        size: remapIconSize('m'),
                        fill: iconColor
                    });
                }
                return _jsx(RenderIcon, {
                    size: "m",
                    color: iconColor
                });
            }
            return null;
        }
        return chevronPlacement === 'end' ? _jsx("span", _objectSpread({
            css: chevronDown
        }, resolveIds(undefined, testID, 'icon'), {
            children: _jsx(ChevronDownIcon, {
                size: "m",
                color: iconColor
            })
        })) : null;
    }, [
        chevronDown,
        chevronRight,
        chevronLeft,
        isRtl,
        chevronPlacement,
        iconColor,
        icon,
        isLeft,
        testID
    ]);
    return _jsx(Col, {
        width: IconNode ? 40 : 8,
        padding: IconNode ? 8 : 0,
        children: _jsx("div", _objectSpread({}, injectTestId(testID), {
            children: IconNode
        }))
    });
};
export default Icon;
